import script from "./RegisterUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterUserForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterUserForm.vue?vue&type=style&index=0&id=3eb7e677&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb7e677"]])

export default __exports__